export default function all(array, predicate) {
    return array.every(predicate);
}
